module.exports = __webpack_public_path__ + "static/media/np.c8a8ef36.svg";